import { useMemo } from 'react';
import { startOfMonth, endOfMonth, startOfWeek, endOfWeek, eachDayOfInterval, isSameMonth } from 'date-fns';

export const useCalendar = (currentDate) => {
    const daysInMonth = useMemo(() => {
        const monthStart = startOfMonth(currentDate);
        const monthEnd = endOfMonth(currentDate);
        const calendarStart = startOfWeek(monthStart);
        const calendarEnd = endOfWeek(monthEnd);

        const days = eachDayOfInterval({
            start: calendarStart,
            end: calendarEnd
        });

        return days.map(date => ({
            date,
            isCurrentMonth: isSameMonth(date, currentDate)
        }));
    }, [currentDate]);

    return {
        daysInMonth
    };
};